<template>
  <vl-icon v-bind="$attrs"></vl-icon>
</template>

<script lang="ts" setup>
defineOptions({
  inheritAttrs: false
});
</script>

<style lang="scss" scoped></style>
